import { render, staticRenderFns } from "./DoorLocks.vue?vue&type=template&id=512a29f4&scoped=true&"
import script from "./DoorLocks.vue?vue&type=script&lang=js&"
export * from "./DoorLocks.vue?vue&type=script&lang=js&"
import style0 from "./DoorLocks.vue?vue&type=style&index=0&id=512a29f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512a29f4",
  null
  
)

export default component.exports